// extracted by mini-css-extract-plugin
module.exports = {"container":"dwzp6yHJIwryF_kij8RB7","info":"_1dnio3piB_g9VktAsMJF-y","description":"_1Qn8CsYeKNAWBfvh_A3zwg","subList":"_3nlB6wWmsbm-QaRovWGZEV","button":"_2haHCw6IN--Lir6pMBNRCy"};